// import './App.css';
import React, { useEffect, useState } from 'react';
// import { OpenCvProvider, useOpenCv } from 'opencv-react'

// import ReactGA from 'react-ga';

// import 'antd/es/style/themes/default.less';
import 'antd/dist/reset.css'; // Import Ant Design styles by less entry
import ImageToSvg from './pages/ImageToSvg/index';
import SvgEditor from "./pages/SvgEditor/index";
import ColoringPageToSvg from "./pages/ColoringPageToSvg";


// const TRACKING_ID = "UA-216085191-1"; // YOUR_OWN_TRACKING_ID
// ReactGA.initialize(TRACKING_ID);


function App() {

  // useEffect(() => {
  //   ReactGA.pageview(window.location.pathname);
  // });




  return (

    <div style={{ marginTop: '35px', padding: '0 10px' }}>
      {document.getElementById('ImageToSvg') != undefined &&
        <ImageToSvg />
      }
      {document.getElementById('ColoringPageToSvg') != undefined &&
        <ColoringPageToSvg />
      }
      {document.getElementById('SvgEditor') != undefined &&
        <SvgEditor />
      }
    </div>

  );
}

export default App;
